<template>
    <v-app>
        <DevFAB />

        <fade-in-background v-if="showFadeInBackground" />
        <dashboard-core-app-bar v-if="showAppBarAndDrawer" :drawer.sync="drawer" @toggle-help="handleHelpClick" />

        <dashboard-core-drawer v-if="showAppBarAndDrawer" :drawer.sync="drawer" />

        <dashboard-core-view />

        <help-center-side-bar v-if="help" :help.sync="help" />
        <dashboard-core-snack-bar />
        <atlas-chat-widget-loader v-if="showAtlasChatWidget" />
    </v-app>
</template>

<script>
import AtlasChatWidgetLoader from "@cmp/atlas/AtlasChatWidgetLoader.vue";
import DevFAB from "@cmp/DevFAB.vue";
import FadeInBackground from "@cmp/core/FadeInBackground.vue";
import DashboardCoreAppBar from "@cmp/core/AppBar.vue";
import DashboardCoreDrawer from "@cmp/core/Drawer.vue";
import DashboardCoreView from "@cmp/core/View.vue";
import HelpCenterSideBar from "@cmp/helpcenter/HelpCenterSideBar.vue";
import DashboardCoreSnackBar from "@cmp/core/AppSnackBar.vue";

export default {
    name: "DashboardIndex",

    metaInfo: {
        title: "Home",
    },

    components: {
        AtlasChatWidgetLoader,
        DashboardCoreSnackBar,
        HelpCenterSideBar,
        DashboardCoreView,
        DashboardCoreDrawer,
        DashboardCoreAppBar,
        FadeInBackground,
        DevFAB,
    },

    data: () => ({
        drawer: false,
        expandOnHover: false,
        help: false,
    }),

    computed: {
        showFadeInBackground() {
            if (!this.$route) {
                return true;
            }

            if (this.$route.meta?.noBackground) {
                return false;
            }

            if (this.$route.meta?.public) {
                return true;
            }

            return false;
        },

        showAppBarAndDrawer() {
            if (!this.$route) {
                return false;
            }

            if (this.$route.meta?.public) {
                return false;
            }

            return true;
        },
        showAtlasChatWidget() {
            return this.showAppBarAndDrawer;
        },
    },
    methods: {
        handleHelpClick() {
            this.help = !this.help;
        },
    },

    created() {
        if (this.$vuetify.breakpoint.mdAndUp) {
            this.drawer = true;
        }
    },
};
</script>
